import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetQueueRequestById } from 'domain/usecases';
import { RemoteGetQueueRequestById } from 'data/usecases';

export const makeRemoteQueueRequestById = (requestId: string): GetQueueRequestById => {
  return new RemoteGetQueueRequestById(makeApiUrl(`/queue/requests/${requestId}`), makeAuthorizeHttpClientDecorator());
};
